import React, { useEffect, useMemo, useState } from "react";
import PropTypes from "prop-types";
import {
  FormControl,
  FormHelperText,
  Grid,
  Select,
  TextField,
  TextareaAutosize,
  Typography,
  MenuItem,
} from "@mui/material";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import dayjs from "dayjs";
import { MenuProps } from "../../utils/constants";

const FormatField = (props) => {
  const { listField, data, errorValues, onChange, onError } = props;

  const [dataState, setDataState] = useState();
  const [errors, setErrors] = useState();
  const checkDate = useMemo(() => {
    return {
      maxDate: "Thời gian phải trước năm 2200",
      minDate: "Thời gian phải sau năm 1800",
      invalidDate: "Thời gian định dạng sai",
    };
  }, []);

  useEffect(() => {
    setErrors(errorValues);
  }, [errorValues]);

  useEffect(() => {
    setDataState(data);
  }, [data]);

  const handleChangeValueInput = (name) => (e) => {
    let { value } = e.target;
    setDataState((prev) => {
      return {
        ...prev,
        [name]: value,
      };
    });
    onChange?.({ name: name, value: value });
  };

  const handleChangeDate = (name) => (value) => {
    setDataState((prev) => {
      return {
        ...prev,
        [name]: value,
      };
    });
    if (dayjs(value)?.isValid()) {
      setErrors((prev) => ({
        ...prev,
        [name]: "",
      }));
      onError({ name: name, value: "" });
    }
    onChange?.({ name: name, value: value });
  };

  const handleOnErrorDate = (name) => (error) => {
    if (error) {
      setErrors((prev) => ({
        ...prev,
        [name]: checkDate[error],
      }));
      onError({ name: name, value: checkDate[error] });
    } else {
      setErrors((prev) => ({
        ...prev,
        [name]: "",
      }));
      onError({ name: name, value: "" });
    }
  };
  const handleToClearDate = (name) => (e) => {
    setDataState((prev) => ({
      ...prev,
      [name]: null,
    }));
    onChange?.({ name: name, value: null });
  };

  const handleOnFocus = (name) => (e) => {
    e.stopPropagation();
    setErrors((prev) => ({
      ...prev,
      [name]: "",
    }));
    onError({ name: name, value: "" });
  };

  const handleInputTypeNumber = (name) => (e) => {
    let value = e.target.value;
    value = value.replace(/[^\d.]/g, "");

    let formattedNumber = "";
    if (value && !isNaN(parseFloat(value))) {
      formattedNumber = parseFloat(value).toLocaleString("en-US");
    }
    setDataState((prev) => ({
      ...prev,
      [name]: formattedNumber ? formattedNumber : "",
    }));
    onChange?.({ name: name, value: formattedNumber ? formattedNumber : "" });
  };

  //float
  const handleValueNumberInput = (name) => (e) => {
    const resultString = e.target.value.replace(/[^0-9.]/g, "");
    setDataState((prev) => {
      return {
        ...prev,
        [name]: resultString,
      };
    });
  };
  const handleOnBlurNumber = (name) => (e) => {
    let value = e.target.value;
    value = value.replace(/[^\d.]/g, "");

    let formattedNumber = "";
    if (value && !isNaN(parseFloat(value))) {
      formattedNumber = parseFloat(value).toLocaleString("en-US", {
        minimumFractionDigits: 0,
        maximumFractionDigits: 3,
      });
    }
    setDataState((prev) => ({
      ...prev,
      [name]: formattedNumber ? formattedNumber : "",
    }));
    onChange?.({ name: name, value: formattedNumber ? formattedNumber : "" });
  };
  return (
    <Grid container spacing={2} sx={{ textAlign: "left" }}>
      {listField?.length > 0 &&
        listField?.map((field) => (
          <Grid item key={field?.key} xs={field.xs} md={field.md} lg={field.lg}>
            <Typography fontSize={"0.75rem"} color={"#000000"} fontWeight={500}>
              {field?.name}{" "}
              {field?.required ? <span style={{ color: "red" }}>*</span> : ""}
            </Typography>
            {field?.type == "text" && (
              <TextField
                fullWidth
                name={field?.key}
                value={dataState?.[field?.key] || ""}
                error={errors ? !!errors?.[field?.key] : false}
                placeholder={`Nhập ${field?.name?.toLowerCase()}`}
                helperText={errors?.[field?.key]}
                onChange={handleChangeValueInput(field?.key)}
                inputProps={{
                  maxLength: field?.maxLength,
                }}
                onFocus={handleOnFocus(field?.key)}
              />
            )}
            {field?.type == "number" && (
              <TextField
                fullWidth
                name={field?.key}
                value={dataState?.[field?.key] || 0}
                error={errors ? !!errors?.[field?.key] : false}
                placeholder={`Nhập ${field?.name?.toLowerCase()}`}
                helperText={errors?.[field?.key]}
                onChange={handleChangeValueInput(field?.key)}
                type="number"
                onFocus={handleOnFocus(field?.key)}
                inputProps={{ pattern: "[0-9]*" }}
                InputProps={{
                  inputProps: {
                    style: { textAlign: "right" },
                  },
                }}
              />
            )}
            {field?.type == "textNumber" && (
              <TextField
                fullWidth
                name={field?.key}
                value={dataState?.[field?.key] || 0}
                error={errors ? !!errors?.[field?.key] : false}
                placeholder={`Nhập ${field?.name?.toLowerCase()}`}
                helperText={errors?.[field?.key]}
                onChange={handleInputTypeNumber(field?.key)}
                onFocus={handleOnFocus(field?.key)}
                disabled={field?.disabled ? true : false}
                inputProps={{
                  style: {
                    textAlign: "right",
                  },
                }}
              />
            )}
            {field?.type == "textArea" && (
              <TextField
                fullWidth
                name={field?.key}
                value={dataState?.[field?.key] || ""}
                error={errors ? !!errors?.[field?.key] : false}
                placeholder={`Nhập ${field?.name?.toLowerCase()}`}
                helperText={errors?.[field?.key]}
                onChange={handleChangeValueInput(field?.key)}
                onFocus={handleOnFocus(field?.key)}
                multiline
                InputProps={{
                  inputComponent: TextareaAutosize,
                  rows: 3,
                }}
                inputProps={{
                  maxLength: field?.maxLength ? field?.maxLength : 255,
                }}
              />
            )}
            {field?.type == "textNumberFloat" && (
              <TextField
                fullWidth
                name={field?.key}
                value={dataState?.[field?.key] || 0}
                error={errors ? !!errors?.[field?.key] : false}
                placeholder={`Nhập ${field?.name?.toLowerCase()}`}
                helperText={errors?.[field?.key]}
                onChange={handleValueNumberInput(field?.key)}
                onFocus={handleOnFocus(field?.key)}
                inputProps={{
                  style: {
                    textAlign: "right",
                  },
                  pattern: "[0-9]*",
                }}
                onBlur={handleOnBlurNumber(field?.key)}
              />
            )}
            {field?.type == "select" && (
              <FormControl fullWidth>
                <Select
                  sx={{ padding: "0.75rem" }}
                  value={
                    field?.array?.length > 0
                      ? dataState?.[field?.key]
                        ? dataState?.[field?.key]
                        : field?.defaultValue
                        ? field?.defaultValue
                        : field?.array?.[0]?.id
                      : field?.defaultValue
                      ? field?.defaultValue
                      : field?.array?.[0]?.id
                  }
                  name={field?.key}
                  // defaultValue={
                  //   field?.defaultValue ? field?.defaultValue : dataState?.[field?.key][0]?.id
                  // }
                  displayEmpty
                  MenuProps={MenuProps}
                  error={errors ? !!errors?.[field?.key] : false}
                  onChange={handleChangeValueInput(field?.key)}
                  onFocus={handleOnFocus(field?.key)}
                >
                  {field?.array &&
                    field?.array?.length > 0 &&
                    field?.array?.map((item) => (
                      <MenuItem key={item.id} value={item.id}>
                        {item?.name}
                      </MenuItem>
                    ))}
                </Select>
                {errors?.[field?.key] && (
                  <FormHelperText sx={{ color: "red", fontSize: "12px" }}>
                    {errors?.[field?.key]}
                  </FormHelperText>
                )}
              </FormControl>
            )}
            {field?.type == "date" && (
              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <DatePicker
                  sx={{ width: "100%", textAlign: "right" }}
                  format="DD/MM/YYYY"
                  value={
                    dataState?.[field?.key]
                      ? dayjs(dataState?.[field?.key])
                      : null
                  }
                  onChange={handleChangeDate(field?.key)}
                  slotProps={{
                    field: {
                      clearable: true,
                      onClear: handleToClearDate(field?.key),
                    },
                    textField: {
                      name: field?.key,
                      error: errors ? !!errors?.[field?.key] : false,
                      helperText: errors?.[field?.key],
                      inputProps: {
                        style: {
                          textAlign: "center",
                        },
                      },
                    },
                  }}
                  onError={handleOnErrorDate(field?.key)}
                  minDate={dayjs("1800-01-01T00:00:00.000")}
                  maxDate={dayjs("2200-12-31T23:59:59.999")}
                />
              </LocalizationProvider>
            )}
          </Grid>
        ))}
    </Grid>
  );
};
FormatField.propTypes = {
  listField: PropTypes.array,
  data: PropTypes.any,
  onChange: PropTypes.func,
  onError: PropTypes.func,
  errorValues: PropTypes.any,
};
export default FormatField;
